import {
  Survey,
  SurveyMetadataFormState,
  SurveyQualificationsFormState,
  SurveyQuotasFormState,
  surveyToMetadataForm,
} from '@ps/survey-utils';

export function buildMetadataFormStateFromSurvey(
  survey: Survey,
): SurveyMetadataFormState {
  return {
    value: surveyToMetadataForm(survey),
    valid: true,
    errors: [],
    isDirty: false,
  };
}

export function buildQualificationsFormStateFromSurvey(
  survey: Survey,
): SurveyQualificationsFormState {
  return {
    value: survey.qualifications ?? [],
    valid: true,
    errors: [],
    isDirty: false,
  };
}

export function buildQuotasFormStateFromSurvey(
  survey: Survey,
): SurveyQuotasFormState {
  return {
    value: survey.quotas ?? [],
    valid: true,
    errors: [],
    isDirty: false,
  };
}
